import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { VideoControlButton } from './VideoControlButton'
import { tID } from '../../utils/utils'
import { CloseIcon } from '../icons/CloseIcon'

export type CloseVideoControlButtonProps = {
  disabled: boolean
  onPress: () => void
  enabledColor?: string
  disabledColor?: string
  iconColor?: string
  size?: number
}

export const CloseVideoControlButton: FunctionComponent<CloseVideoControlButtonProps> = ({
  disabled,
  enabledColor,
  disabledColor,
  iconColor,
  onPress,
  size = 64,
}) => {
  const { formatMessage } = useIntl()
  const { colors } = useTheme()
  const { videoControlButton } = colors.components
  const iconSize = size / 3.2

  return (
    <VideoControlButton
      enabledColor={enabledColor || videoControlButton.enabledColor.fill}
      enabledIcon={<CloseIcon fillColor={iconColor || colors.iconInverse} size={iconSize} />}
      disabledColor={disabledColor || videoControlButton.disabledColor.fill}
      disabledIcon={<CloseIcon fillColor={iconColor || colors.iconInverse} size={iconSize} />}
      onPress={onPress}
      disabled={disabled}
      testID={tID('close')}
      size={size}
      accessibilityLabel={formatMessage({
        defaultMessage: 'Close',
        description: 'Button to close session',
      })}
    />
  )
}
